import {RESERVE_TYPE} from '../actions/types';

const INITIAL_STATE = {
  items: '',
  routes: false,
  openType: false,
  isCancel: false,
};

const Reserve = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESERVE_TYPE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default Reserve;
